import React, { useEffect, useState } from "react";
import axios from "axios";
import "./prboth.css";
import babyfl from "../../assets/babyshow.jpg";
import { Link } from "react-router-dom";
import nodata from "../../assets/nobgnodata.png";

function BabyProducts({ selectedTool, setSelectedTool }) {
  const getPlainText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;
  const [visiblePages, setVisiblePages] = useState([1, 2, 3]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.post(
          "https://musicplayer.preggyzone.com/api/get_product_list",
          {
            country_code: "in",
            device_type: "andriod",
            package_name: "com.skyraan.preggyzone",
            app_version: 1,
            except_product_ids: 5,
          }
        );

        setProducts(response.data.data.products || response.data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = products.filter(
    (product) => product.product_type === "baby"
  );
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);
  const startIndex = (currentPage - 1) * productsPerPage;
  const visibleProducts = filteredProducts.slice(
    startIndex,
    startIndex + productsPerPage
  );

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      updateVisiblePages(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      updateVisiblePages(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const updateVisiblePages = (page) => {
    let startPage = Math.max(1, page - 1);
    let endPage = Math.min(totalPages, startPage + 2);

    if (endPage === totalPages) {
      startPage = Math.max(1, totalPages - 2);
    }

    setVisiblePages(
      [...Array(endPage - startPage + 1)].map((_, i) => startPage + i)
    );
  };
  return (
    <div>
      <div className="banner-container-pr">
        <div style={{ backgroundColor: "white", borderRadius: "20px" }}>
          <div className="bread-container">
            <nav aria-label="breadcrumb">
              <ol className="crumb">
                <li className="breadcrumblist">
                  <Link
                    to="/"
                    className="breadcrumb-link"
                    onClick={() => setSelectedTool("")}
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumblist">
                  <Link to="/products" className="breadcrumb-link">
                    Products
                  </Link>
                </li>
                <li className="breadcrumblist active">BabyProducts</li>
              </ol>
            </nav>
          </div>
          <div className="banner-content-pr" style={{ position: "relative" }}>
            <div className="banner-text-pr">
              <h1 className="animate-heading-pr">Baby Products</h1>
              <p
                className="animate-subheading-pr"
                style={{ textAlign: "justify" }}
              >
                Find everything you need to care for your little one, from cosy
                essentials to fun, playful must-haves. Our collection is
                designed to keep your baby comfortable, happy, and safe, making
                your parenting journey a little easier and a lot more enjoyable!
              </p>
              {/* <a href="#toget">
              <button className="cta-button-pr">Explore Now</button>
            </a> */}
            </div>
            <div className="banner-image-pr">
              <img src={babyfl} alt="Baby Banner" />
            </div>
          </div>
        </div>
      </div>

      <div className="products-container" id="toget">
        <div className="pr-cat-main">
          {loading ? (
            <p>Loading products...</p>
          ) : error ? (
            <>
              <div className="ndf-container">
                <img src={nodata} alt="No-Data-Found" id="no-data-found" />
                <h4>No Products Found</h4>
              </div>
            </>
          ) : visibleProducts.length > 0 ? (
            <div>
              <div className="product-cards-container">
                {visibleProducts.map((product, index) => (
                  <div key={index} className="product-card">
                    <img
                      src={product.product_thumb_image}
                      alt={product.product_name}
                      className="product-image"
                    />
                    <div className="product-details">
                      <h3
                        className="product-description"
                        style={{
                          fontWeight: "bold",
                          color: "#68053C",
                          fontSize: "18px",
                        }}
                      >
                        {getPlainText(product.product_name)}
                      </h3>

                      <a
                        href={product.product_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button className="cta-button-pr">Buy Now</button>
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination Buttons */}
              <div className="paginationn-container">
                <button
                  className="ca-button-pr"
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {visiblePages.map((page) => (
                  <button
                    key={page}
                    className={`page-button ${
                      currentPage === page ? "active-page" : ""
                    }`}
                    onClick={() => handlePageClick(page)}
                  >
                    {page}
                  </button>
                ))}

                <button
                  className="ca-button-pr"
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <p>No products available</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default BabyProducts;
